export const meeting = [
  {
    path: '/meeting',
    component: () => import(/* webpackChunkName: "meeting" */ '@/views/meeting/Meeting'),
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "meeting" */ '@/views/meeting/components/MeetingEditBody'),
      },
      {
        path: ':id/edit',
        component: () => import(/* webpackChunkName: "meeting" */ '@/views/meeting/components/MeetingEditBody'),
      },
    ]
  },
]
